import { ChangeDetectionStrategy, Component, computed, inject, input, model } from '@angular/core'
import { TbAccordionComponent } from '@components-library/tb-accordion/tb-accordion.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TranslocoDirective } from '@jsverse/transloco'
import { ModalManagerService } from '@components-library/tb-modal-manager/modal-manager.service'
import { TbTab } from '@components-library/tb-tab/tb-tab.component'
import { FieldEntities } from '@models/ui'
import { FieldSectionContentComponent } from '@app/feature/header/workspace-controls/advanced-options/field-section/field-section-content/field-section-content.component'
import {
    FieldConfigurationComponent,
    FieldConfigurationOutput,
    FieldData,
} from '@app/feature/header/workspace-controls/advanced-options/field-section/field-configuration/field-configuration.component'

@Component({
    selector: 'app-field-section',
    imports: [
        TbAccordionComponent,
        TbIconComponent,
        TranslocoDirective,
        FieldSectionContentComponent,
    ],
    templateUrl: './field-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldSectionComponent {
    private readonly modalManagerService = inject(ModalManagerService)

    readonly schemaTabs = input.required<TbTab[]>()
    readonly inactiveFields = model.required<string[]>()
    readonly fieldsBySchema = model.required<Record<string, FieldEntities>>()

    protected readonly availableTabs = computed(() => {
        return this.schemaTabs().filter((tab) => this.fieldsBySchema()[tab.id])
    })

    openFieldsSettings() {
        this.modalManagerService
            .openDialog<FieldConfigurationComponent, FieldData, FieldConfigurationOutput>({
                component: FieldConfigurationComponent,
                data: {
                    schemaTabs: this.schemaTabs(),
                    inactiveFields: this.inactiveFields(),
                    fieldBySchema: this.fieldsBySchema(),
                },
            })
            .subscribe((data) => {
                if (!data) return

                this.inactiveFields.set(data.inactiveFields)
                this.fieldsBySchema.set(data.fieldBySchema)
            })
    }
}
